'use client';

import React from 'react';
import { useIntl } from 'react-intl';
import { Box, Text, VStack } from '@ui-library';

import { ReservationOption } from '@/models';
import { PropertyDateFormat } from '@/lib/dateFormat';
import { getRoomTitle } from '@/components/check-in/helper/reservationHelper';
import { ReservationDetailsBadges } from './ReservationDetailBadge';
import { DateRangeDisplay } from './DateRangeDisplay';

type ReservationOptionCardProps = {
  reservation: ReservationOption;
  displayGuestRoomNumber: boolean;
  primaryColor: string;
  companyTimezone: string;
  propertyDateFormat?: PropertyDateFormat;
  onClick?: (reservation: ReservationOption) => void;
};

export const ReservationOptionCard = ({
  reservation,
  displayGuestRoomNumber,
  primaryColor,
  companyTimezone,
  propertyDateFormat,
  onClick,
}: ReservationOptionCardProps) => {
  const intl = useIntl();

  return (
    <Box
      p="4"
      w="full"
      border="1px solid"
      borderColor="fog.400"
      borderRadius="2xl"
      cursor="pointer"
      onClick={() => onClick?.(reservation)}
      minW="20rem"
      maxWidth="md"
    >
      <VStack gap={2} alignItems="flex-start">
        <Text fontWeight="semibold" color={primaryColor}>
          {getRoomTitle(
            reservation.roomTypeName
              ? {
                  roomTypeName: reservation.roomTypeName,
                  roomName: reservation.roomName ?? null,
                }
              : undefined,
            intl,
            displayGuestRoomNumber,
          )}
        </Text>
        <DateRangeDisplay
          startDate={reservation.startDate}
          endDate={reservation.endDate}
          companyTimezone={companyTimezone}
          color={primaryColor}
          propertyDateFormat={propertyDateFormat}
        />
        <ReservationDetailsBadges
          startDate={reservation.startDate}
          endDate={reservation.endDate}
          adultsCount={reservation.adults}
          childrenCount={reservation.children}
          companyTimezone={companyTimezone}
        />
        {reservation.reservationId && (
          <Text fontSize="sm" color="black">
            {reservation.reservationId}
          </Text>
        )}
      </VStack>
    </Box>
  );
};
